import analytics from '@viewlift/analytics/analytics-core/index.cjs'
import googleAnalytics from '@viewlift/analytics/google-analytics/index.cjs'
import userBeacon from '@viewlift/analytics/user-beacon/index.cjs'

export { ANALYTICSEVENTS } from '../../../constants/analyticsEvents';

  export const FB_EVENTS = {
    PAGE_VIEW: 'PageView',
    PURCHASE: 'Purchase',
    ADD_PAYMENT_INFO: 'AddPaymentInfo',
    INITIATE_CHECKOUT: 'InitiateCheckout',
    COMPLETE_REGISTRATION: 'CompleteRegistration',
    ADD_TO_CART: 'AddToCart',
    START_TRIAL: 'StartTrial',
    SUBSCRIBE: 'Subscribe',
    VIEW_CONTENT: 'ViewContent',
    ADD_TO_WISHLIST: 'AddToWishlist',
    REMOVED_FROM_WATCHLIST: 'RemovedFromWatchlist',
    SUBSCRIPTION_INITIATED: 'SubscriptionInitiated',
    SUBSCRIPTION_COMPLETED: 'SubscriptionCompleted',
    SUBSCRIPTION_FAILED: 'SubscriptionFailed',
    TVOD_PURCHASE: 'tvod_purchase',
    TVOD_PURCHASE_COMPLETION: 'tvod_purchase_completion',
    SEARCH: 'Search',
    LOGIN: 'Login',
    LOGOUT: 'Logout',
    PLAY_STARTED: 'Play Started',
    WATCHED: 'Watched',
  };
  
  export const pixel_Events = {
    ADD_TO_CART: 'AddToCart',
    PAGE_VIEW: 'PageView',
    PURCHASE: 'Purchase',
    ADD_PAYMENT_INFO: 'Add Payment Info',
    INITIATE_CHECKOUT: 'Initiate Checkout',
    COMPLETE_REGISTRATION: 'Complete Registration',
    SUBSCRIPTION_INITIATED: "SubscriptionInitiated",
    SUBSCRIPTION_COMPLETED: 'SubscriptionCompleted'
  };
  

export default function trackEvent(eventName, payload,trackingID) {
  if (typeof window !== 'undefined') { 
    if(window?.dataLayer) {
      window.dataLayer.push({
        'event': eventName,
        ...payload
      })
    }
    try {
      if(!trackingID) return
      analytics({
        app: 'analytics',
        eventName: eventName,
        plugins: [
        googleAnalytics({
          trackingId: trackingID || (window?.app_data?.appcmsPlatform?.analytics?.googleAnalyticsId),
          initialize: () => {
          },
          payload: payload
        }),
      ]
      })
    } catch (err) {
      console.error(err);
    }
  } else {
    console.log("Analytics Tracking is supported on client side only")
  }
}

export function trackUserEvent(payload) {
  if (typeof window !== 'undefined') { 
    return analytics({
      app: 'user-analytics',
      apiBaseUrl: window?.app_data?.appcmsMain?.apiConfig?.userBeaconUrl,
      plugins: [
       userBeacon({
         initialize: () => {
           console.log('FIRE INIT FROM PLUGIN USER')
         },
         payload: payload,
       }),
     ]
    })
  } else {
    console.log("Analytics Tracking is supported on client side only")
  }
}